// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentLayout_root__2dOds","buttonContainer":"PaymentLayout_buttonContainer__rV5YN"};